import React from 'react';
import {Field, reduxForm, reset} from 'redux-form'

import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import SearchIcon from 'material-ui/svg-icons/action/search';
import ArrowDwonloadIcon from 'material-ui/svg-icons/file/file-download';
import ArrowUploadIcon from 'material-ui/svg-icons/file/file-upload';

import Checkbox from 'material-ui/Checkbox';
import * as colors from 'material-ui/styles/colors';

import moment from 'moment'

import FormText from '../../components/FormText'
import FormSelect from '../../components/FormSelect'
import FormAutoComplete2 from '../../components/FormAutoComplete2'
import FormDatePicker from '../../components/FormDatePicker'
import FormGrLe from '../../components/FormGrLe'
import FormCheckBox from '../../components/FormCheckBox'
import * as commons from '../../commons';
import styles from '../../styles'


const validate = values => {
  const errors = {}
  const requiredFields = [
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })

  if (values.startDate && values.endDate) {
    if (moment(values.startDate).unix() > moment(values.endDate).unix()) {
      errors.startDate = '期間が不正です。'
      errors.endDate = '期間が不正です。'
    }
  }

  if (values.orderAmmount && !commons.validateNumber(values.orderAmmount)) {
    errors.orderAmmount = '数値入力を入力して下さい。'
  }

  if (values.budgetAvg && !commons.validateNumber(values.budgetAvg)) {
    errors.budgetAvg = '数値入力を入力して下さい。'
  }

  if (values.resultAvg && !commons.validateNumber(values.resultAvg)) {
    errors.resultAvg = '数値入力を入力して下さい。'
  }

  return errors
}

const dataSourceConfig = {
  text: 'textKey',
  value: 'valueKey',
};

class YosanListForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      menuValueOrderAmmount: 1,
      menuValueBudgetAvg: 1,
      menuValueResultAvg: 1,

      branchOfficeId: 0
    }
  }


  handleNewRequest = (change) => (value, index) => {

    const {
      kenmeiData
    } = this.props

    if (index === -1) {
      return
    }

    // const kenmei = kenmeiData[index] || {}

    // change('kenmeiName', kenmei.name)
    // change('branchOfficeId', kenmei.branchOfficeId)
    // change('departmentId', kenmei.departmentId)
    // change('customerId', kenmei.customerId)
    // change('constructionId', kenmei.constructionId)

  }

  handleGrLeChange(type) {

    let updateObj = {}
    updateObj[type] = this.state[type] === 1 ? 2 : 1

    this.setState(
      Object.assign({}, this.state, updateObj)
    )

  }

    render() {

    const {
      kenmeiData = [],
      branchOfficeData,
      departmentData,
      customerData,
      constructionData,
      selectedBranchOfficeId,
      error,
      change,
      dispatch,
      handleSubmit,
      onSearchClick,
      onFormClear,
      onCsvDownload,
      onSummaryCsvDownload,
        onSummaryCsvDisplay,
      onReportDownload,
      onFormUpload,
      onRoumuUpload,
        auth,
    } = this.props

    const kenmeiDataSource = kenmeiData ? kenmeiData.map(x => {
      return {
        textKey: `${x.code} - ${x.name}`,
        valueKey: x.code
      }
    }): []

    return (

      <form onSubmit={handleSubmit(() => {})}>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}

        <div className="">

          <div className="row">
            <div className="col-3">

              <Field
                name="kenmeiCode"
                dataSourceConfig={dataSourceConfig}
                dataSource={kenmeiDataSource}
                component={FormAutoComplete2}
                onNewRequest={this.handleNewRequest(change)}
                floatingLabelText="件名番号"
                filter={(searchText, key) => {
                  if (searchText == '') {
                      return true
                  }
                  return key.indexOf(searchText) !== -1
                }}
                textFieldStyle={{ width: '100%' }}
                style={{ width: '100%' }}
              /> 

            </div>
            <div className="col-6">
              <Field
                name="kenmeiName"
                component={FormText}
                label="件名名称"
                style={{ width: '100%' }}
              />
            </div>

            <div className="col-3">
              <Field
                name="status"
                component={FormSelect}
                style={{ width: '100%' }}
                label="ステータス"
                multiple={true}
              >
                <MenuItem primaryText="" />
                <MenuItem value={0} primaryText="承認待" />
                <MenuItem value={1} primaryText="承認済" />
                <MenuItem value={2} primaryText="着工" />
                <MenuItem value={3} primaryText="完工" />
              </Field>
            </div>


          </div>

          <div className="row">
            <div className="col-3">

              <Field
                name="branchOfficeId"
                component={FormSelect}
                style={{ width: '100%' }}
                label="支店"
                value={this.state.branchOfficeId}
              >
                <MenuItem value={''} primaryText="" />
                {branchOfficeData &&
                 branchOfficeData.map((x, index) =>{
                   return (<MenuItem key={index} value={x.id} primaryText={x.name}/>)
                 })
                }
              </Field>

            </div>
            <div className="col-3">
              <Field
                name="departmentId"
                component={FormSelect}
                style={{ width: '100%' }}
                label="部署"
              >
                <MenuItem value={''} primaryText="" />
                {!departmentData ? '' :
                selectedBranchOfficeId ?
                 departmentData.map((x, index) =>{
                   if (selectedBranchOfficeId == x.branchOfficeId) {
                      return (<MenuItem key={index} value={x.id} primaryText={x.name}/>)
                   }
                 }) : 
                 <MenuItem primaryText="支店を選択" />
                }
              </Field>
            </div>

            <div className="col-3">

              <Field
                name="customerId"
                component={FormSelect}
                style={{ width: '100%' }}
                label="客先"
              >
                <MenuItem value={''} primaryText="" />
                {customerData &&
                 customerData.map((x, index) =>{
                   return (<MenuItem key={index} value={x.id} primaryText={x.name}/>)
                 })
                }
              </Field>

            </div>

            <div className="col-3">

              <Field
                name="constructionId"
                component={FormSelect}
                style={{ width: '100%' }}
                label="工事種別"
              >
                <MenuItem value={''} primaryText="" />
                {constructionData &&
                 constructionData.map((x, index) =>{
                   return (<MenuItem key={index} value={x.id} primaryText={x.name}/>)
                 })
                }
              </Field>

            </div>


          </div>

          <div className="row">
            <div className="col-2">

              <Field
                  name="startDateYear"
                  component={FormSelect}
                  style={{ width: '100%' }}
                  label="期間年（自）"
              >
                  <MenuItem value={''} primaryText="" />
                  <MenuItem value={2017} primaryText={2017}/>
                  <MenuItem value={2018} primaryText={2018}/>
                  <MenuItem value={2019} primaryText={2019}/>
                  <MenuItem value={2020} primaryText={2020}/>
                  <MenuItem value={2021} primaryText={2021}/>
                  <MenuItem value={2022} primaryText={2022}/>
                  <MenuItem value={2023} primaryText={2023}/>
                  <MenuItem value={2024} primaryText={2024}/>
                  <MenuItem value={2025} primaryText={2025}/>
                  <MenuItem value={2026} primaryText={2026}/>
                  <MenuItem value={2027} primaryText={2027}/>
              </Field>

            </div>
            <div className="col-2">

                <Field
                    name="startDateMonth"
                    component={FormSelect}
                    style={{ width: '100%' }}
                    label="期間月（自）"
                >
                    <MenuItem value={''} primaryText="" />
                    <MenuItem value={1} primaryText={1}/>
                    <MenuItem value={2} primaryText={2}/>
                    <MenuItem value={3} primaryText={3}/>
                    <MenuItem value={4} primaryText={4}/>
                    <MenuItem value={5} primaryText={5}/>
                    <MenuItem value={6} primaryText={6}/>
                    <MenuItem value={7} primaryText={7}/>
                    <MenuItem value={8} primaryText={8}/>
                    <MenuItem value={9} primaryText={9}/>
                    <MenuItem value={10} primaryText={10}/>
                    <MenuItem value={11} primaryText={11}/>
                    <MenuItem value={12} primaryText={12}/>
                </Field>

            </div>
            <div className="col-1" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
              <div style={{ paddingBottom: 7 }}><span style={{ paddingBottom: 5, color: colors.grey600 }}>〜</span></div>
            </div>

            <div className="col-2">

                <Field
                    name="endDateYear"
                    component={FormSelect}
                    style={{ width: '100%' }}
                    label="期間年（至）"
                >
                    <MenuItem value={''} primaryText="" />
                    <MenuItem value={2017} primaryText={2017}/>
                    <MenuItem value={2018} primaryText={2018}/>
                    <MenuItem value={2019} primaryText={2019}/>
                    <MenuItem value={2020} primaryText={2020}/>
                    <MenuItem value={2021} primaryText={2021}/>
                    <MenuItem value={2022} primaryText={2022}/>
                    <MenuItem value={2023} primaryText={2023}/>
                    <MenuItem value={2024} primaryText={2024}/>
                    <MenuItem value={2025} primaryText={2025}/>
                    <MenuItem value={2026} primaryText={2026}/>
                    <MenuItem value={2027} primaryText={2027}/>
                </Field>

            </div>
            <div className="col-2">

                <Field
                    name="endDateMonth"
                    component={FormSelect}
                    style={{ width: '100%' }}
                    label="期間月（至）"
                >
                    <MenuItem value={''} primaryText="" />
                    <MenuItem value={1} primaryText={1}/>
                    <MenuItem value={2} primaryText={2}/>
                    <MenuItem value={3} primaryText={3}/>
                    <MenuItem value={4} primaryText={4}/>
                    <MenuItem value={5} primaryText={5}/>
                    <MenuItem value={6} primaryText={6}/>
                    <MenuItem value={7} primaryText={7}/>
                    <MenuItem value={8} primaryText={8}/>
                    <MenuItem value={9} primaryText={9}/>
                    <MenuItem value={10} primaryText={10}/>
                    <MenuItem value={11} primaryText={11}/>
                    <MenuItem value={12} primaryText={12}/>
                </Field>

            </div>

          </div>
          <div className="row">
            <div className="col-3" style={{overflow: 'hidden'}}>
              <FormGrLe 
                name='orderAmmount' 
                label='受注金額'
                onChange={this.handleGrLeChange.bind(this, 'menuValueOrderAmmount')} 
                menuValue={this.state.menuValueOrderAmmount}/>
            </div>
            <div className="col-3" style={{overflow: 'hidden'}}>
              <FormGrLe 
                name='budgetAvg' 
                label='予定粗利率' 
                onChange={this.handleGrLeChange.bind(this, 'menuValueBudgetAvg')} 
                menuValue={this.state.menuValueBudgetAvg}/>
            </div>
            <div className="col-3" style={{overflow: 'hidden'}}>
              <FormGrLe 
                name='resultAvg' 
                label='実粗利率' 
                onChange={this.handleGrLeChange.bind(this, 'menuValueResultAvg')} 
                menuValue={this.state.menuValueResultAvg}/>
            </div>
          </div>

            <div className="row" style={{marginTop: 20}}>

                <div className="col-12" style={{textAlign: 'right'}}>

                   {auth.user.permission == 2 &&
                        <RaisedButton
                            containerElement="label"
                            label="労務UPLOAD"
                            labelPosition="before"
                            labelStyle={{ color: colors.white, lineHeight: '40px' }}
                            style={{ height: '40px', width: '150px', marginRight: '20px' }}
                            backgroundColor={colors.green800}
                            icon={<ArrowUploadIcon color={colors.white} />}
                        >
                            <input
                                onChange={onRoumuUpload}
                                style={{ display: 'none' }}
                                type="file"
                            />
                        </RaisedButton>
                    }

                    {auth.user.permission == 2 &&
                        <RaisedButton
                            containerElement="label"
                            label="経費UPLOAD"
                            labelPosition="before"
                            labelStyle={{ color: colors.white, lineHeight: '40px' }}
                            style={{ height: '40px', width: '150px', marginRight: '20px' }}
                            backgroundColor={colors.green800}
                            icon={<ArrowUploadIcon color={colors.white} />}
                        >
                            <input
                                onChange={onFormUpload}
                                style={{ display: 'none' }}
                                type="file"
                            />
                        </RaisedButton>
                    }

                    <FlatButton
                        label="合計(画面)"
                        labelPosition="before"
                        primary={true}
                        labelStyle={{ color: colors.white, lineHeight: '40px' }}
                        style={{ height: '40px', width: '130px', marginRight: '20px' }}
                        backgroundColor={colors.grey600}
                        hoverColor={colors.grey800}
                        icon={<ArrowDwonloadIcon color={colors.white} />}
                        onClick={handleSubmit(onSummaryCsvDisplay)}
                    />

                    <FlatButton
                        label="合計(CSV)"
                        labelPosition="before"
                        primary={true}
                        labelStyle={{ color: colors.white, lineHeight: '40px' }}
                        style={{ height: '40px', width: '130px', marginRight: '20px' }}
                        backgroundColor={colors.grey600}
                        hoverColor={colors.grey800}
                        icon={<ArrowDwonloadIcon color={colors.white} />}
                        onClick={handleSubmit(onSummaryCsvDownload)}
                    />

                    <FlatButton
                        label="CSV出力"
                        labelPosition="before"
                        primary={true}
                        labelStyle={{ color: colors.white, lineHeight: '40px' }}
                        style={{ height: '40px', width: '130px' }}
                        backgroundColor={colors.grey600}
                        hoverColor={colors.grey800}
                        icon={<ArrowDwonloadIcon color={colors.white} />}
                        onClick={handleSubmit(onCsvDownload)}
                    />


                    {/*<FlatButton*/}
                        {/*label="帳票出力"*/}
                        {/*labelPosition="before"*/}
                        {/*primary={true}*/}
                        {/*labelStyle={{ color: colors.white, lineHeight: '40px' }}*/}
                        {/*style={{ height: '40px', width: '120px'}}*/}
                        {/*backgroundColor={colors.grey600}*/}
                        {/*hoverColor={colors.grey800}*/}
                        {/*icon={<ArrowDwonloadIcon color={colors.white} />}*/}
                        {/*onClick={handleSubmit(onReportDownload)}*/}
                    {/*/>*/}
                </div>

            </div>
        </div>

          {/*<div style={{ textAlign: 'right', padding: 8, marginTop: 20}}>*/}
          <div className="row" style={{marginTop: 20}}>

            <div className="col-2" style={{paddingTop: 5, display: 'flex', justifyContent:'flex-start'}}>
              <div>
                <Field label="予算超のみ" name="excessCheck" component={FormCheckBox} 
                  style={{ ...styles.checkRemember.style, fontSize: 13, width: '130px'}}
                  labelStyle={styles.checkRemember.labelStyle}
                  iconStyle={styles.checkRemember.iconStyle}
                />
              </div>
            </div>
            <div className="col-10" style={{textAlign: 'right'}}>

              <FlatButton
                label="クリア"
                primary={true}
                labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
                style={{height: '40px', width: '100px', marginRight: '20px'}}
                onClick={() => {
                  this.setState(
                    Object.assign({}, this.state, {
                      menuValueOrderAmmount: 1,
                      menuValueBudgetAvg: 1,
                      menuValueResultAvg: 1
                    })
                  )
                  onFormClear()
                }}
              />

              <FlatButton
                label="検索"
                labelPosition="before"
                primary={true}
                labelStyle={{ color: colors.white, lineHeight: '40px' }}
                style={{ height: '40px', width: '130px' }}
                backgroundColor={colors.blue500}
                hoverColor={colors.blue700}
                icon={<SearchIcon color={colors.white} />}
                onClick={handleSubmit(
                  onSearchClick(
                    this.state.menuValueOrderAmmount,
                    this.state.menuValueBudgetAvg,
                    this.state.menuValueResultAvg
                  ))
                }
              />

            </div>
          </div>


      </form>

  )
  }
}

YosanListForm = reduxForm({
  form: 'yosanListForm',
  enableReinitialize: true,
})(YosanListForm)

export default YosanListForm;



// WEBPACK FOOTER //
// ./src/containers/yosan/YosanListForm.js